import {Swiper} from "swiper";
import {Navigation, Pagination} from "swiper/modules";

/**
* Initializes the product slider component.
*/
export const productSlider = () => {
    handleProductSliders();
    redirectToPdp()

    window.addEventListener("slider-delayed-fetched", function (e) {
        if (document.querySelector(`[data-swiper-pd-slider="${e.detail}"]`)) {

            fetchDelayedSliders(document.querySelector(`[data-slider-delayed="${e.detail}"]`));
        }
    });

    document.querySelectorAll("[data-slider-tab]").forEach(function (sliderTabElement) {
        const sliderIndex = sliderTabElement.dataset.sliderTab;

        sliderTabElement.addEventListener("click", () => {
            $(document.querySelector("[data-swiper-carousels]")).spinner().start();

            toggleActiveTab(sliderTabElement);

            if (document.querySelector(`[data-swiper-pd-slider="${sliderIndex}"]`).children[0]) {
                toggleSliderVisibility(document.querySelector(`[data-swiper-pd-slider="${sliderIndex}"]`));
                $.spinner().stop();
            } else {
                window.dispatchEvent(new CustomEvent("slider-delayed-fetched", {"detail" : sliderIndex}));
            }
        });
    });

    sliderMutationObserver();

    if (document.querySelector("[data-sliders-tabs]")) {
        document.querySelectorAll("[data-sliders-tabs]").forEach(function (sliderTabElement) {
            initSliderTabs(sliderTabElement);
        });
    }
};

/**
 * Adjusts the position of the tab for a slider component.
*/
const adjustSlidePosition = () => {
    const $sliderWrapper = $("[data-sliders-swiper-tabs]");
    const $slides = $sliderWrapper.find("[data-ti-swiper-slide]");
    let totalSlidesWidth = 0;

    // Calculate total width of all slides
    $slides.each(function () {
        var slideWidth = $(this).width();
        var gutterLeft = parseInt($(this).css("padding-left"), 10) || 0;
        var gutterRight = parseInt($(this).css("padding-right"), 10) || 0;

        totalSlidesWidth += slideWidth + gutterLeft + gutterRight;
    });

    var gap = parseInt($sliderWrapper.css("gap"), 10) || 0;
    totalSlidesWidth += gap * ($slides.length - 1);

    const viewportWidth = $(window).width();
 
    $sliderWrapper.removeClass("ti-sliders-center ti-sliders-left");
    if (totalSlidesWidth > viewportWidth) {
        $sliderWrapper.addClass("ti-sliders-left");
    } else {
        $sliderWrapper.addClass("ti-sliders-center");
    } 
};

/**
* Initializes a Swiper slider
* @param {HTMLElement} sliderWrapper - the swiper slider wrapper element
* @param {string} indexSliderWrapper - the index of the swiper slider wrapper element
* @param {Object} options - the swiper options object
*/
const initProductSlider = (sliderWrapper) => {
    const indexSliderWrapper = sliderWrapper.dataset.swiperPdSlider;
    const swiperPageType = sliderWrapper.dataset.swiperPageType;
    let numberOfSliders = 4;
    let spaceBetweenMobile = 6;
    let spaceBetweenDesktop = 6;
    let slidesPerViewValue = 1.1;

    if (indexSliderWrapper == "news") {
        numberOfSliders = 3;
        spaceBetweenDesktop = 24;
    }

    let breakpoints= {
        768: {
            slidesPerView: numberOfSliders,
            spaceBetween: spaceBetweenDesktop,
            slidesPerGroup: 4,
            pagination: {
                dynamicBullets: false,
                clickable: true
            },
            slidesOffsetAfter:0
        }
    };

    if (swiperPageType == "cart") {
        slidesPerViewValue = 2;
        spaceBetweenMobile = 38;
        breakpoints= {
            768: {
                slidesPerGroup: 1,
                pagination: {
                    dynamicBullets: false,
                    clickable: true
                }
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 38,
                slidesOffsetAfter:0
            }
        };
    }

    adjustSlidePosition();
    var swiperSlider = new Swiper(".slider-product-" + indexSliderWrapper, {
        slidesPerView: slidesPerViewValue,
        modules: [Navigation, Pagination],
        bulletActiveClass: "swiper-product-bullet-active",
        bulletClass: "swiper-product-bullet",
        centerInsufficientSlides: swiperPageType === "cart",
        cssMode: swiperPageType === "cart",
        spaceBetween: spaceBetweenMobile,
        pagination: {
            el: `.swiper-product-pagination-${indexSliderWrapper}`,
            dynamicBullets: swiperPageType === "cart"
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints
    });

    if (swiperSlider && swiperSlider.classNames) {
        swiperSlider.classNames.push(`slider-inited-${indexSliderWrapper}`);
    }
};

/**
* Fetches delayed sliders from the given url
*/
const fetchDelayedSliders = (sliderTarget) => {
    let productIds = sliderTarget.dataset.sliderDelayedIds;
    const sliderIndex = sliderTarget.dataset.sliderDelayed;
    let url = sliderTarget.dataset.sliderDelayedUrl + "?queryProductIds=" + productIds + "&sliderIndex=" + sliderIndex;

    fetch(url, {
        method: "GET",
    })
        .then((response) => response.text())
        .then(function (text) {
            $(`[data-swiper-pd-slider="${sliderIndex}"]`).closest("[data-slider-common-wrapper]").siblings("[data-slider-common-wrapper]").addClass("hidden");

            sliderTarget.innerHTML = text;
            $(sliderTarget).closest("[data-slider-common-wrapper]")[0].classList.remove("hidden");

            toggleSliderVisibility(document.querySelector(`[data-swiper-pd-slider="${sliderIndex}"]`));
            initProductSlider(document.querySelector(`[data-slider-delayed="${sliderIndex}"]`));
            
            if ($(`[data-swiper-pd-slider="${sliderIndex}"]`).closest("[data-swiper-carousels]").hasClass("hidden-from-einstein")) {
                $(`[data-swiper-pd-slider="${sliderIndex}"]`).closest("[data-swiper-carousels]").removeClass("hidden-from-einstein");
            }

            updateArrowsPosition(sliderTarget);
            $.spinner().stop();
        });
};

/**
* Toggles the visibility of the product slider
* @param {HTMLElement} slider - the target slider element
*/
const toggleSliderVisibility = (slider) => {
    $(slider).closest("[data-slider-common-wrapper]").siblings("[data-slider-common-wrapper]").addClass("hidden");
    $(slider).closest("[data-slider-common-wrapper]")[0].classList.remove("hidden");

    updateArrowsPosition(slider);
};

/**
* Toggles the active tab in the product slider
* @param {Element} sliderTabElement - the tab element to be activated
*/
const toggleActiveTab = (sliderTabElement) => {
    const $this = $(sliderTabElement);

    $this.siblings(".ti-slider-tab-active").removeClass("ti-slider-tab-active");
    $this.siblings().attr("aria-pressed", "false");
    $this.addClass("ti-slider-tab-active");
    $this.attr("aria-pressed", "true");

};

/**
* Initializes the product slider and adds mutation observer to it
* @returns {void}
*/
const sliderMutationObserver = () => {
    const observerConfig = {
        attributes: true,
        childList: true,
        subtree: true
    };

    const $swiperSliderRecommendation = $("[data-ti-slider-pd-einstein]");

    $swiperSliderRecommendation.each(function () {
        const $this = $(this);

        // Callback function to execute when mutations are observed
        const callback = function (mutationsList) {
            for (let mutation of mutationsList) {
                if (mutation.type === "childList") {
                    if ($this.find("[data-swiper-pd-einstein]").not(".swiper-initialized").length === 0) {
                        return;
                    }

                    initProductSlider($this.find("[data-swiper-pd-einstein]")[0]);
                    
                    updateArrowsPosition($this.find("[data-swiper-pd-einstein]")[0]);
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(this, observerConfig);

        setTimeout(function () {
            if (observer) {
                const productTilesRecommendationLength = $this.find("[data-swiper-pd-einstein]").data("swiperPdSlider");
                const productTilesLength = $this.find("[data-swiper-pd-slider]").data("swiperPdSlider");

                if (productTilesRecommendationLength && !$this.find("[data-swiper-pd-einstein]").hasClass("swiper-initialized")) {
                    initProductSlider($this.find("[data-swiper-pd-einstein]")[0]);
                } else if (!productTilesRecommendationLength && !productTilesLength) {
                    $this.addClass("d-none");
                }

                observer.disconnect();
            } else {
                $this.addClass("d-none");
            }
        }, 3000);
    });
};

/**
* Initializes the slider tabs
* @param {HTMLElement} sliderTabsWrapper - the wrapper element for the slider tabs
*/
const initSliderTabs = (sliderTabsWrapper) => {
    const indexSliderWrapper = sliderTabsWrapper.dataset.slidersTabs;

    new Swiper(".slider-tabs-" + indexSliderWrapper, {
        slidesPerView: "auto",
        freeMode: true
    });
};

$("body").on("carousel:setup", function (e, $parentElement) {
    updateArrowsPosition($parentElement);
});

/**
* Updates the position of the arrows in the product slider
* @param {HTMLElement} slider - The product slider element
*/
const updateArrowsPosition = (slider) => {
    const productImage = slider.querySelector("[data-image-product]");

    if (productImage) {
        const imageHeight = productImage.width;
        const prevArrow = slider.querySelector(".swiper-button-prev");
        const nextArrow = slider.querySelector(".swiper-button-next");
        const imageCenterY = (imageHeight / 2) - 5; 

        nextArrow.style.top = imageCenterY + "px";
        prevArrow.style.top = imageCenterY + "px";

        nextArrow.classList.add("slider-arrow-visible");
        prevArrow.classList.add("slider-arrow-visible");

        productImage.onload = function () {
            updateArrowsPosition(slider);
        };
    }
};

/**
* Initializes and updates product sliders
*/
const handleProductSliders = () => {
    if (document.querySelector("[data-swiper-slider-init]")) {
        document.querySelectorAll("[data-swiper-slider-init]:not(.hidden)").forEach(function (sliderElement) {
            initProductSlider(sliderElement);
            updateArrowsPosition(sliderElement);
        });
    }
};

const redirectToPdp = () => {
    $(document).off("click.redirectToPdp", "[data-redirect-to-product-tile]").on("click.redirectToPdp", "[data-redirect-to-product-tile]", function (e) {
        window.location.href = $(this).siblings(".product-tile").attr("href");
    });
};
